import { Button } from '@neo/index'
import { Play, RotateCcw, Square } from 'lucide-react'
import { flowService } from 'v2/shared/services/flow-service'
import { agentLogger } from 'v2/utils/logger'
import { useStartEval } from './hooks/use-start-eval'
import { useEvalStore } from './store'

export const EvalControlButtons = () => {
  const events = useEvalStore((state) => state.events)
  const isEvalRunning = useEvalStore((state) => state.isEvalRunning)
  const isPaused = useEvalStore((state) => state.isPaused)
  const currentEvalId = useEvalStore((state) => state.currentEvalId)
  const startEval = useStartEval()

  const pauseEval = () => {
    if (currentEvalId) {
      flowService
        .cancelEval(currentEvalId)
        .then(() => {
          agentLogger.info('Backend eval cancelled successfully', { currentEvalId })
        })
        .catch((error: unknown) => {
          agentLogger.error('Failed to cancel backend eval', { currentEvalId, error })
        })
    }
  }

  const handlePauseResume = () => {
    if (isPaused) {
      startEval({ evalId: currentEvalId })
    } else {
      pauseEval()
    }
  }

  const handleRestartEval = () => {
    startEval()
  }

  return (
    <>
      {(isEvalRunning || isPaused) && (
        <div className="absolute bottom-4 right-4 z-10">
          <Button
            variant="default"
            size="sm"
            className="px-3 py-2 gap-1.5 shadow-lg"
            onClick={handlePauseResume}
            aria-label={isPaused ? 'Start simulation' : 'Stop simulation'}
            data-testid="button-pause-resume-eval"
          >
            {isPaused ? (
              <>
                <Play className="h-3.5 w-3.5" />
                Start simulation
              </>
            ) : (
              <>
                <Square className="h-3.5 w-3.5" />
                Stop simulation
              </>
            )}
          </Button>
        </div>
      )}
      {!isEvalRunning && !isPaused && events.length > 0 && (
        <div className="absolute bottom-4 right-4 z-10">
          <Button
            variant="default"
            size="sm"
            className="px-3 py-2 gap-1.5 shadow-lg"
            onClick={handleRestartEval}
            aria-label="Restart simulation"
            data-testid="button-restart-eval"
          >
            <RotateCcw className="h-3.5 w-3.5" />
            Restart Simulation
          </Button>
        </div>
      )}
    </>
  )
}
